<template>

  <div>

    <b-card-title class="ml-4 mb-3">{{ name }}</b-card-title>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :path="path" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="pageViewId"
                 sortable disable-default-buttons :foreign-key="foreignKey" sortableCheckColumn="sortable"
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit">


      <template #item(label)="{item}">

        {{item.label}}
        <small v-if="item.note !== ''">({{item.note}})</small>
      </template>


      <template #item(key)="{item}">

        <div v-if="item.key.indexOf('field_') > - 1">
          Customizado
        </div>
        <div v-else>
          Padrão do Sistema
        </div>

      </template>

      <template #list-buttons="{item}">

        <div>

          <t-button v-show="item.show && !item.fixed" small
                    @click="toggleShowField(item.pageViewId, item.label, item.show)">
            <b-icon-eye></b-icon-eye>
          </t-button>

          <t-button v-show="!item.show && !item.fixed" outline-secondary small
                    @click="toggleShowField(item.pageViewId, item.label, item.show)">
            <b-icon-eye-slash></b-icon-eye-slash>
          </t-button>

        </div>


        <t-help v-show="item.fixed" title="Campo fixo não poderá ser oculto ou alterada a ordem"/>

      </template>

    </t-form-list>

  </div>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import pageFormFieldMixin from "@/mixins/page/pageFormFieldMixin";

import tFormList from "@/components/template/form/list/t-form-list";
import ui from "@/assets/scripts/ui";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageFormFieldMixin],
  name: 'PageView',
  components: {tFormList},
  data() {
    return {
      path: "setting/page-view", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "pageViewId",
      foreignKeyColumn: "pageId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "pageViewId", keyDelete: "pageViewId"},
        {key: "label", label: "Campo", cols: "6"},
        {key: "key", label: "Tipo", cols: "3"},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      error: {//Campos que podem receber retorno de erro do backend

      },

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    pageId: Number,
    typeImage: Boolean,
    name: String,
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormField()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.pageViewId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------
      let newItems = []

      for (let item of this.items) {
        if (!item.show) {
          item.class = "bg-light"
        } else {
          item.class = ''
        }

        if (item.fixed) {
          item.sortable = false
        } else {
          item.sortable = true
        }

        newItems.push(item)
      }

      this.items = newItems
      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    toggleShowField(pageViewId, label, show) {

      const item = {
        pageId: this.foreignKey,
        pageViewId: pageViewId,
        show: !show
      }

      crudGeneral.update(this.path, item).catch(error => this.responseError(error))

      let style_class = ''

      if (show) {
        style_class = 'bg-light'
        ui.toast(this, "Campo: " + label, "Ocultado com sucesso!")
      } else {
        ui.toast(this, "Campo: " + label, "Exibido com sucesso!")
      }

      this.items.find(a => a.pageViewId === pageViewId).class = style_class
      this.items.find(a => a.pageViewId === pageViewId).show = !show
      this.items.push()

    }

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
